<template>
    <div class="separator-white">
        <div></div>
    </div>
</template>
<script>
export default {
    name: 'SeparatorWhite',
    components: {},
    data() {
        return {
        }
    },
    computed: {},
    methods: {}
}
</script>